import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, PageLayoutComponent, SpinnerModule } from '@spartacus/storefront';

import { KnBrCustomPipesModule } from 'src/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';
import { KnBrMyQuoteSearchResultComponent } from './kn-br-my-quote-search-result.component';

@NgModule({
  declarations: [KnBrMyQuoteSearchResultComponent],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    NgbTooltipModule,
    KnBrCustomPipesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrStep2CustomerQuoteSearchResultComponent: {
          component: () =>
            import('./kn-br-my-quote-search-result.component').then((c) => c.KnBrMyQuoteSearchResultComponent),
        },
      },
    } as CmsConfig),
    RouterModule.forChild([
      {
        data: { pageLabel: '/myQuotes', cxRoute: 'myQuotes' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          myQuotes: {
            paths: ['myQuotes'],
          },
          productSearch1355: {
            paths: ['c/1355'],
          },
          productListPage: {
            paths: ['c/1'],
          }
        },
      },
    } as RoutingConfig),
  ],
})
export class KnBrMyQuoteSearchResultModule { }
